import { Button, message, Modal, Input } from "antd";
import { WplywContext } from "../../../../context/wplywContext";
import { useAuth } from "../../../../context/AuthContext";
import axios from '../../../../context/axiosConfig';
import { useContext, useEffect, useState } from "react";
import isCan from "../../../../components/isCan";
const { TextArea } = Input;

const ArchiveButton = () => {
    const { wplyw, setWplyw } = useContext(WplywContext);
    const { user } = useAuth();
    const [cando, setCando] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [archiveComment, setArchiveComment] = useState("");
    const perms = user.perms;

    useEffect(() => {
        const fetchPermissions = async () => {
            const requiredPerms = wplyw.wplyw_data.data.msr_wplywy.archived ? 
                ["can_unarchive_wplyw"] : 
                ["can_archive_wplyw"];
            const result = await isCan(requiredPerms, perms);
            setCando(result);
        };
        fetchPermissions();
    }, [perms, wplyw.wplyw_data.data.msr_wplywy.archived]);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setArchiveComment("");
    };

    const handleArchive = async () => {
        try {
            const hide = message.loading(
                wplyw.wplyw_data.data.msr_wplywy.archived ? 
                "Przywracanie z archiwum..." : 
                "Archiwizowanie...", 
                0
            );
            
            const currentComment = wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_comment || '';
            const newComment = archiveComment ? (currentComment ? currentComment + '\nPowód archiwizacji: ' + archiveComment : archiveComment) : currentComment;
            
            const response = await axios.post("/wplyw/archive", {
                wplywId: wplyw.msr_wplywy_id,
                ownwplywId: wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
                archive: wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_archived ? '0' : '1',
                comment: newComment,
                user: user.user.mlg_users_id
            });

            hide();

            if (response.data.status) {
                message.success(
                    wplyw.wplyw_data.data.msr_wplywy.archived ? 
                    "Przywrócono z archiwum!" : 
                    "Zarchiwizowano pomyślnie!"
                );
                setWplyw({ ...wplyw, reload: !wplyw.reload });
                setIsModalVisible(false);
                setArchiveComment("");
            } else {
                message.error(`Błąd: ${response.data.message}`);
            }
        } catch (error) {
            console.error("Error handling archive:", error);
            message.error("Wystąpił błąd podczas operacji archiwizacji.");
        }
    };

    return cando && (
        <>
            <Button 
                onClick={wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_archived == '1' ? handleArchive : showModal} 
                disabled={!cando}
            >
                {wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_archived == '1' ? 'Przywróć z archiwum' : 'Archiwizuj'}
            </Button>
            <Modal
                title="Właśnie archiwizujesz wpływ"
                open={isModalVisible}
                onOk={handleArchive}
                onCancel={handleCancel}
                okText="Archiwizuj"
                cancelText="Anuluj"
            >
                <TextArea
                    rows={4}
                    placeholder="Opisz dlaczego to robisz"
                    value={archiveComment}
                    onChange={(e) => setArchiveComment(e.target.value)}
                    defaultValue={wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_comment}
                />
            </Modal>
        </>
    );
};

export default ArchiveButton;